module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"search":"Search help center","empty":"There are no relevant articles for this page. Please use the search feature."}}')
  delete Component.options._Ctor
}
